<div class="placeholder-message">

  @if(!noStarImage) {
  <img src="./../../../assets/icons/star-saffron.svg" alt="Bulgari star">
  }

  <p>{{message}}</p>
  <ng-content></ng-content>
</div>
